import withNetworkProvider from './withNetworkProvider'

export default withNetworkProvider
